<template>
    <v-menu offset-y :close-on-content-click="false" >
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="indigo" icon v-bind="attrs" v-on="on">
                <v-icon small :color="internalValue && internalValue.length === 0 ? undefined : 'red'">
                    mdi-filter-variant
                </v-icon>
            </v-btn>
        </template>
        <v-card style="max-height: 500px; display: flex; flex-direction: column;">
            <v-card-text class="pa-6" style="overflow-y: auto; flex: 1 1 auto;">
                <v-checkbox
                    v-for="(item, i) in items"
                    :key="i"
                    v-model="internalValue"
                    :label="item"
                    :value="item"
                    :ripple="false" 
                    dense
                    class="filter_checkbox"
                    @change="checkboxChange"
                >
                </v-checkbox>
            </v-card-text>
            <v-divider/>
            <v-btn text block @click="clearValues" color="warning">Clear</v-btn>
        </v-card>
    </v-menu>
</template>

<script>
/**
 * Component used in data_table header to enable filtering of data
 */
export default {
    props: {
        items: Array,
        value: Array
    },
    data() {
        return { internalValue: [] }
    },
    methods: {
        checkboxChange() {
            this.$emit('input', this.internalValue)
        },
        clearValues() {
            this.internalValue = []
            this.checkboxChange()
        }
    }
}
</script>

<style>
.filter_checkbox .v-label {
    color: black
}
</style>